'use strict';
import * as $i_otpauth from "otpauth";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eui$002etotp$002e$002dMigration$0024$0024anon$00243 from "./presto.ui.totp.-Migration$$anon$3.js";
import * as $j_presto$002eui$002etotp$002e$002dMigration$0024$0024anon$00244 from "./presto.ui.totp.-Migration$$anon$4.js";
import * as $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount from "./presto.ui.totp.-Migration$-Account.js";
import * as $j_presto$002eui$002etotp$002e$002dMigration$0024$002dReader from "./presto.ui.totp.-Migration$-Reader.js";
var $p;
function $p_Lpresto_ui_totp_Migration$__base32__AB__T($thiz, bytes) {
  var array = new Int8Array(bytes.b.length);
  var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_ArrayOps$().cJM(bytes);
  if ((!this$2.gA)) {
    var i = this$2.dI;
    while (true) {
      var arg1 = i;
      array[arg1] = bytes.b[arg1];
      if ((i === this$2.sg)) {
        break;
      }
      i = ((i + this$2.ct) | 0);
    }
  }
  return new $i_otpauth.Secret((() => {
    var array$2 = null;
    var outer = null;
    array$2 = array;
    outer = $thiz;
    var this$2$1 = ({});
    this$2$1.buffer = null;
    if ((outer === null)) {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
    }
    this$2$1.buffer = array$2.buffer;
    return this$2$1;
  })()).base32;
}
export { $p_Lpresto_ui_totp_Migration$__base32__AB__T as $p_Lpresto_ui_totp_Migration$__base32__AB__T };
function $p_Lpresto_ui_totp_Migration$__account__AB__Lpresto_ui_totp_Migration$Account($thiz, bytes) {
  var reader = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dReader.$c_Lpresto_ui_totp_Migration$Reader(bytes);
  var result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account("", "", "", 0, 0, 0, 30);
  while (reader.adQ()) {
    var tag = reader.A5().e;
    matchResult5: {
      var _1 = ((tag >>> 3) | 0);
      var _2 = (7 & tag);
      if (((_1 === 1) && (_2 === 2))) {
        var \u03b41$ = result;
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account($p_Lpresto_ui_totp_Migration$__base32__AB__T($thiz, reader.Sp()), \u03b41$.n8, \u03b41$.n6, \u03b41$.ow, \u03b41$.ox, \u03b41$.n7, \u03b41$.lK);
        break matchResult5;
      }
      if (((_1 === 2) && (_2 === 2))) {
        var \u03b42$ = result;
        var name$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_String$().ctK(reader.Sp(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_nio_charset_UTF\uff3f8$());
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account(\u03b42$.jA, name$1, \u03b42$.n6, \u03b42$.ow, \u03b42$.ox, \u03b42$.n7, \u03b42$.lK);
        break matchResult5;
      }
      if (((_1 === 3) && (_2 === 2))) {
        var \u03b43$ = result;
        var issuer$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_String$().ctK(reader.Sp(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_nio_charset_UTF\uff3f8$());
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account(\u03b43$.jA, \u03b43$.n8, issuer$2, \u03b43$.ow, \u03b43$.ox, \u03b43$.n7, \u03b43$.lK);
        break matchResult5;
      }
      if (((_1 === 4) && (_2 === 0))) {
        var \u03b44$ = result;
        var algorithm$3 = reader.A5().e;
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account(\u03b44$.jA, \u03b44$.n8, \u03b44$.n6, algorithm$3, \u03b44$.ox, \u03b44$.n7, \u03b44$.lK);
        break matchResult5;
      }
      if (((_1 === 5) && (_2 === 0))) {
        var \u03b45$ = result;
        var digits$4 = reader.A5().e;
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account(\u03b45$.jA, \u03b45$.n8, \u03b45$.n6, \u03b45$.ow, digits$4, \u03b45$.n7, \u03b45$.lK);
        break matchResult5;
      }
      if (((_1 === 6) && (_2 === 0))) {
        var \u03b46$ = result;
        var kind$5 = reader.A5().e;
        result = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account(\u03b46$.jA, \u03b46$.n8, \u03b46$.n6, \u03b46$.ow, \u03b46$.ox, kind$5, \u03b46$.lK);
        break matchResult5;
      }
      reader.cvF(_2);
    }
  }
  return result;
}
export { $p_Lpresto_ui_totp_Migration$__account__AB__Lpresto_ui_totp_Migration$Account as $p_Lpresto_ui_totp_Migration$__account__AB__Lpresto_ui_totp_Migration$Account };
function $p_Lpresto_ui_totp_Migration$__direct__T__s_util_Try($thiz, uri) {
  var Pattern = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "(?i)otpauth://([^/?]*)/?([^?]*)\\??(.*)", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
  try {
    matchResult10: {
      var \u03b47$___1;
      var \u03b47$___2;
      var \u03b47$___3;
      if ((uri !== null)) {
        var x38 = Pattern.cwr(uri);
        if ((!x38.k())) {
          var x39 = x38.q();
          if ((x39.ck(3) === 0)) {
            var \u03b47$___1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_LinearSeqOps__apply__I__O(x39, 0);
            var \u03b47$___2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_LinearSeqOps__apply__I__O(x39, 1);
            var \u03b47$___3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_LinearSeqOps__apply__I__O(x39, 2);
            break matchResult10;
          }
        }
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(uri);
    }
    var kind$2 = \u03b47$___1;
    var path$2 = \u03b47$___2;
    var query$2 = \u03b47$___3;
    var params = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_ArrayOps$().a3Z($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().cvO(query$2, 38)).b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$3) => (_$3 !== "")))).a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((p) => {
      var x43 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__split__T__I__AT(p, "=", 2);
      if ((x43 !== null)) {
        if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Array$UnapplySeqWrapper$().Te(x43, 2) === 0)) {
          var x47 = x43.b[0];
          var x48 = x43.b[1];
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(x47.toLowerCase(), $p_Lpresto_ui_totp_Migration$__decode$2__T__T($thiz, x48));
        }
        if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Array$UnapplySeqWrapper$().Te(x43, 1) === 0)) {
          var x45 = x43.b[0];
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(x45.toLowerCase(), "");
        }
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x43);
    }))).gN($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bL);
    var label = $p_Lpresto_ui_totp_Migration$__decode$2__T__T($thiz, path$2);
    matchResult12: {
      var \u03b48$___1;
      var \u03b48$___2;
      var x49 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__indexOf__I__I(label, 58);
      if ((x49 === (-1))) {
        var \u03b48$___1 = "";
        var \u03b48$___2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(label);
        break matchResult12;
      }
      var \u03b48$___1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().afE(label, x49));
      var \u03b48$___2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().a2f(label, ((1 + x49) | 0)));
    }
    var prefix = \u03b48$___1;
    var name = \u03b48$___2;
    var this$24 = params.fJ("secret", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction0((() => "")));
    var $x_6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__replaceAll__T__T__T(this$24.toUpperCase(), "[\\s=-]", "");
    var this$25 = params.bv("issuer");
    var this$28 = ((this$25.k() || (this$25.q() !== "")) ? this$25 : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    var $x_5 = (this$28.k() ? prefix : this$28.q());
    matchResult13: {
      var $x_4;
      var this$29 = params.bv("algorithm");
      if (this$29.k()) {
        var x50 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
      } else {
        var arg1$1 = this$29.q();
        var x50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(arg1$1.toUpperCase());
      }
      matchAlts1: {
        matchAlts2: {
          if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x50)) {
            break matchAlts2;
          }
          if (((x50 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some) && (x50.a0 === "SHA1"))) {
            break matchAlts2;
          }
          break matchAlts1;
        }
        var $x_4 = 1;
        break matchResult13;
      }
      if ((x50 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var x56 = x50.a0;
        if ((x56 === "SHA256")) {
          var $x_4 = 2;
          break matchResult13;
        }
        if ((x56 === "SHA512")) {
          var $x_4 = 3;
          break matchResult13;
        }
        var $x_4 = 4;
        break matchResult13;
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x50);
    }
    matchResult14: {
      var $x_3;
      var x59 = params.bv("digits");
      matchAlts3: {
        matchAlts4: {
          if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x59)) {
            break matchAlts4;
          }
          if (((x59 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some) && (x59.a0 === "6"))) {
            break matchAlts4;
          }
          break matchAlts3;
        }
        var $x_3 = 1;
        break matchResult14;
      }
      if ((x59 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        if ((x59.a0 === "8")) {
          var $x_3 = 2;
          break matchResult14;
        }
        var $x_3 = 3;
        break matchResult14;
      }
      throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x59);
    }
    matchResult15: {
      var $x_2;
      var x66 = kind$2.toLowerCase();
      if ((x66 === "totp")) {
        var $x_2 = 2;
        break matchResult15;
      }
      if ((x66 === "hotp")) {
        var $x_2 = 1;
        break matchResult15;
      }
      var $x_2 = 3;
    }
    var this$30 = params.bv("period");
    var this$34 = (this$30.k() ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_Integer$().ij(this$30.q(), 10)));
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$c_Lpresto_ui_totp_Migration$Account($x_6, name, $x_5, $x_4, $x_3, $x_2, ((this$34.k() ? 30 : this$34.q()) | 0)));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.aeS(new $j_presto$002eui$002etotp$002e$002dMigration$0024$0024anon$00244.$c_Lpresto_ui_totp_Migration$$anon$4($thiz));
}
export { $p_Lpresto_ui_totp_Migration$__direct__T__s_util_Try as $p_Lpresto_ui_totp_Migration$__direct__T__s_util_Try };
function $p_Lpresto_ui_totp_Migration$__decode$1__T__s_util_Try($thiz, data) {
  try {
    var this$2 = decodeURIComponent(data);
    var this$5 = this$2.split(" ").join("+");
    var this$8 = this$5.split("-").join("+");
    var b64 = this$8.split("_").join("/");
    var reader = new $j_presto$002eui$002etotp$002e$002dMigration$0024$002dReader.$c_Lpresto_ui_totp_Migration$Reader($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_ju_Base64$().a7a.cqg(b64));
    var result = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().bQ();
    while (reader.adQ()) {
      var tag = reader.A5().e;
      matchResult6: {
        var _1 = ((tag >>> 3) | 0);
        var _2 = (7 & tag);
        if (((_1 === 1) && (_2 === 2))) {
          result.c0($p_Lpresto_ui_totp_Migration$__account__AB__Lpresto_ui_totp_Migration$Account($thiz, reader.Sp()));
          break matchResult6;
        }
        reader.cvF(_2);
      }
    }
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(result.cb());
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.aeS(new $j_presto$002eui$002etotp$002e$002dMigration$0024$0024anon$00243.$c_Lpresto_ui_totp_Migration$$anon$3());
}
export { $p_Lpresto_ui_totp_Migration$__decode$1__T__s_util_Try as $p_Lpresto_ui_totp_Migration$__decode$1__T__s_util_Try };
function $p_Lpresto_ui_totp_Migration$__data$2__T__s_Option($thiz, uri$1) {
  var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "[?&]data=([^&]+)", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()).cEX(uri$1);
  return (this$3.k() ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_util_matching_Regex$MatchData__group__I__T(this$3.q(), 1)));
}
export { $p_Lpresto_ui_totp_Migration$__data$2__T__s_Option as $p_Lpresto_ui_totp_Migration$__data$2__T__s_Option };
function $p_Lpresto_ui_totp_Migration$__decode$2__T__T($thiz, s) {
  return decodeURIComponent(s.split("+").join(" "));
}
export { $p_Lpresto_ui_totp_Migration$__decode$2__T__T as $p_Lpresto_ui_totp_Migration$__decode$2__T__T };
/** @constructor */
function $c_Lpresto_ui_totp_Migration$() {
}
export { $c_Lpresto_ui_totp_Migration$ as $c_Lpresto_ui_totp_Migration$ };
$p = $c_Lpresto_ui_totp_Migration$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_totp_Migration$;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$() {
}
export { $h_Lpresto_ui_totp_Migration$ as $h_Lpresto_ui_totp_Migration$ };
$h_Lpresto_ui_totp_Migration$.prototype = $p;
$p.a3u = (function(uri) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(uri);
  var lower = this$1.toLowerCase();
  if ((!(!lower.startsWith("otpauth://")))) {
    return $p_Lpresto_ui_totp_Migration$__direct__T__s_util_Try(this, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(uri)).cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$2) => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().ag($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_presto$002eui$002etotp$002e$002dMigration$0024$002dAccount.$d_Lpresto_ui_totp_Migration$Account.r().C)([_$2]))))));
  } else if ((!(!(!lower.startsWith("otpauth-migration://"))))) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "O QR Code n\u00e3o \u00e9 de 2FA (esperado otpauth:// ou exporta\u00e7\u00e3o do Google Authenticator)"));
  } else {
    var x34 = $p_Lpresto_ui_totp_Migration$__data$2__T__s_Option(this, uri);
    if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() === x34)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "QR Code de exporta\u00e7\u00e3o sem dados"));
    }
    if ((x34 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
      return $p_Lpresto_ui_totp_Migration$__decode$1__T__s_util_Try(this, x34.a0);
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x34);
  }
});
$p.csW = (function(a) {
  return ((a.n7 === 1) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("\u00c9 HOTP (por contador); o Presto s\u00f3 suporta TOTP") : ((a.n7 > 2) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Tipo de 2FA desconhecido; o Presto s\u00f3 suporta TOTP") : (((a.ow > 1) || (a.ox > 1)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("N\u00e3o usa SHA1 com 6 d\u00edgitos; o Presto geraria c\u00f3digos errados") : ((a.lK !== 30) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some((("Troca o c\u00f3digo a cada " + a.lK) + "s; o Presto s\u00f3 suporta 30s")) : ((a.jA === "") ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Veio sem chave secreta") : ((!$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_ju_regex_Pattern$().cKK("[A-Z2-7]+=*", a.jA)) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Chave secreta inv\u00e1lida (n\u00e3o \u00e9 Base32)") : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()))))));
});
$p.cPx = (function(uri) {
  return this.a3u(uri).jQ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x$1) => {
    if ((x$1 !== null)) {
      if ((x$1.ck(0) === 0)) {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "A exporta\u00e7\u00e3o n\u00e3o traz nenhuma conta"));
      }
      if ((x$1.ck(1) === 0)) {
        var x77 = x$1.aG(0);
        var this$7 = this.csW(x77);
        if (this$7.k()) {
          var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(x77.jA);
        } else {
          var arg1 = this$7.q();
          var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), ((("'" + x77.GV()) + "': ") + arg1)));
        }
        return $x_1;
      }
    }
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (((("Este QR Code traz " + x$1.U()) + " contas (") + $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(x$1.a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$7) => _$7.GV()))), "", ", ", "")) + "). Exporte s\u00f3 a conta desejada no Google Authenticator")));
  })));
});
var $d_Lpresto_ui_totp_Migration$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$, "presto.ui.totp.Migration$", ({
  a4i: 1
}));
export { $d_Lpresto_ui_totp_Migration$ as $d_Lpresto_ui_totp_Migration$ };
var $n_Lpresto_ui_totp_Migration$;
function $m_Lpresto_ui_totp_Migration$() {
  if ((!$n_Lpresto_ui_totp_Migration$)) {
    $n_Lpresto_ui_totp_Migration$ = new $c_Lpresto_ui_totp_Migration$();
  }
  return $n_Lpresto_ui_totp_Migration$;
}
export { $m_Lpresto_ui_totp_Migration$ as $m_Lpresto_ui_totp_Migration$ };
//# sourceMappingURL=presto.ui.totp.-Migration$.js.map
